import { BESIDE_STOREFRONT } from "./mount";

/**
 * Links and assets that belong to the storefront (hanamaru), not to this app.
 *
 * In production both apps share an origin -- kyou.id/help is routed here, the
 * rest of kyou.id to hanamaru -- so a root-relative path like `/user/cart`
 * reaches the storefront on staging and production alike. So does the local
 * nginx setup (deployment/nginx.local.conf). Only the bare dev server has no
 * storefront behind it, so there the same paths point at kyou.id.
 *
 * Plain `<a href>` only: react-router would treat these as routes of this app.
 */
const ORIGIN = process.env.NODE_ENV === "development" && !BESIDE_STOREFRONT ? "https://kyou.id" : "";

export function storefrontUrl(path) {
  return `${ORIGIN}${path}`;
}

/** Catalog search, the same query hanamaru's navbar builds (SearchMenu.tsx). */
export function catalogSearchUrl(query) {
  const params = new URLSearchParams({ q: query, page: "1,40", sort: "newest" });
  if (query.toLowerCase().indexOf("wipeout") !== -1) params.set("sold", "false");

  return storefrontUrl(`/search?${params.toString()}`);
}
